<template>
    <!-- Theme one -->
    <div v-if="themeStore.themeIndex === 1">
        <FirstRechargeOne :data-set="dataSet" ref="firstRechrgeRef" @check-scroll="checkScroll"
            @go-to-deposit="goToDeposit" @scroll-left="scrollLeft" @scrollRight="scrollRight" @get-claim="getClaim" />
    </div>
    <!-- Theme two -->
    <div v-if="themeStore.themeIndex === 2">
        <FirstRechargeTwo :data-set="dataSet" ref="firstRechrgeRef" @check-scroll="checkScroll"  @go-to-deposit="goToDeposit"
            @scroll-left="scrollLeft" @scrollRight="scrollRight" @get-claim="getClaim" />
    </div>
     <!-- Theme three -->
    <div v-if="themeStore.themeIndex === 3" class="firstRecharge">
         <FirstRechargeThree :data-set="dataSet" ref="firstRechrgeRef" @check-scroll="checkScroll"  @go-to-deposit="goToDeposit"
            @scroll-left="scrollLeft" @scrollRight="scrollRight" @get-claim="getClaim" />
    </div>
     <!-- Theme four -->
    <div v-if="themeStore.themeIndex === 4" class="firstRecharge">
        <FirstRechargeFour :data-set="dataSet" ref="firstRechrgeRef" @check-scroll="checkScroll"  @go-to-deposit="goToDeposit"
            @scroll-left="scrollLeft" @scrollRight="scrollRight" @get-claim="getClaim" />
    </div>
     <CarteiraView ref="walletPopupRef"/>
    <StatusPopup ref="statusRef" :is-show-success="isSuccess" :content="toastContent" />
    <LoadingScreen ref="loadingRef" />
</template>

<script setup lang="ts">
import { getActivityInformations } from '@/api/common';
import { ref, onMounted, computed, nextTick } from 'vue';
import StatusPopup from '@/components/common/statusPopup.vue';
import LoadingScreen from '@/components/common/loadingScreen.vue';
import { getFirstRechargeClaim } from '@/api/activity';
import { useUserStore } from '@/stores/user';
import { FirstRechargeConfig, FirstRechargeData, RecordItem } from './supportScript';
import FirstRechargeOne from '@/themes/themeOne/firstRecharge/firstRecharge.vue';
import FirstRechargeTwo from '@/themes/themeTwo/firstRecharge/firstRecharge.vue';
import FirstRechargeFour from '@/themes/themeFour/firstRecharge/firstRecharge.vue';
import FirstRechargeThree from '@/themes/themeThree/firstRecharge/firstRecharge.vue';
import { useThemeStore } from '@/stores/theme';
import { useRouter } from 'vue-router';
import CarteiraView from '../carteiraView/carteiraView.vue';

const router = useRouter()
const themeStore = useThemeStore()
const userStore = useUserStore()
const isSuccess = ref(false)
const statusRef = ref();
const toastContent = ref('');
const loadingRef = ref();
const firstRechrgeRef = ref()
const walletPopupRef = ref()

const historyList = ref<any>([])
const showLeft = ref(false);
const showRight = ref(false);
const tabsRef = ref<any>(null);
const isShowTabs = ref(true);
const firstRechargeConfig = ref<FirstRechargeConfig | null>(null);
const activityDescription = ref<string[]>([]);
const recordList = ref<RecordItem[]>([])
const firstRechargeAmount = ref(0)
const bannerIcon = ref('')

const formattedMessages = computed(() =>
    activityDescription.value.map(msg => msg.replace(/\\n/g, '\n'))
);
const dataSet = computed<FirstRechargeData>(() => ({
    historyList: historyList.value,
    showLeft: showLeft.value,
    showRight: showRight.value,
    tabsRef: tabsRef.value,
    isShowTabs: isShowTabs.value,
    firstRechargeConfig: firstRechargeConfig.value,
    activityDescription: activityDescription.value,
    recordList: recordList.value,
    firstRechargeAmount: firstRechargeAmount.value,
    bannerIcon: bannerIcon.value,
    formattedMessages: formattedMessages.value
}))
const getActivityInfo = () => {
    loadingRef.value.open();
    let data = {
        activityId: "first_recharge"
    }
    getActivityInformations(data).then(res => {
        loadingRef.value.close();
        const tempObj = res.data.config.config;
        bannerIcon.value = res.data?.floatIcon
        recordList.value = res.data.config.recordList || [];
        historyList.value = res.data.config.recordHistoryList || [];
        firstRechargeAmount.value = res.data.config.firstRechargeAmount || 0;
        if (recordList.value?.length > 0) {
            console.log('11');
        } else {
            if (res.data.config.firstRechargeLevel == 0 || res.data.config.firstRechargeLevel == null) {
                firstRechargeConfig.value = res.data.config;
                isShowTabs.value = true;
            } else {
                const arrname: { config: any[]; firstRechargeLevel: number; firstRechargeAmount: number; } = {
                    config: [],
                    firstRechargeLevel: 0,
                    firstRechargeAmount: 0
                };
                const matchedConfig = tempObj.find((item: any) => item.amount === res.data.config.firstRechargeLevel);
                arrname.config.push(matchedConfig);
                arrname.firstRechargeLevel = res.data.config.firstRechargeLevel;
                firstRechargeConfig.value = arrname;
                isShowTabs.value = false;
                firstRechrgeRef.value.setActive(0);
            }

        }
        activityDescription.value = JSON.parse(res.data.activityIntro);
    }).catch(err => {
        if (err.code != 401) {
            loadingRef.value.close();
            showError(err);
        }
    })
}

const checkScroll = () => {
    nextTick(() => {
        const scrollEl = tabsRef.value?.$el?.querySelector('.van-tabs__nav');
        if (!scrollEl) return;
        const { scrollWidth, clientWidth, scrollLeft } = scrollEl;
        showLeft.value = scrollLeft > 0;
        showRight.value = scrollLeft + clientWidth < scrollWidth;
    });
};

const scrollLeft = () => {
    const scrollEl = tabsRef.value?.$el?.querySelector('.van-tabs__nav');
    if (scrollEl) {
        scrollEl.scrollBy({ left: -150, behavior: 'smooth' });
        setTimeout(checkScroll, 300);
    }
};

const scrollRight = () => {
    const scrollEl = tabsRef.value?.$el?.querySelector('.van-tabs__nav');
    if (scrollEl) {
        scrollEl.scrollBy({ left: 150, behavior: 'smooth' });
        setTimeout(checkScroll, 300);
    }
};

const showError = (message: string) => {
    toastContent.value = message;
    isSuccess.value = false;
    statusRef.value.open()
}

const showSuccess = (message: string) => {
    toastContent.value = message;
    isSuccess.value = true;
    statusRef.value.open()
}

const getClaim = () => {
    loadingRef.value.open();
    let data = {
        uid: userStore.id
    }
    getFirstRechargeClaim(data).then((res: any) => {
        loadingRef.value.close();
        showSuccess(res.msg)
        loadingRef.value.open();
        getActivityInfo()
    }).catch(err => {
        loadingRef.value.close();
        showError(err);
    })
}

const goToDeposit = (amount : any) => {
    userStore.setRechargeBonusType(2)
    if (themeStore.themeIndex === 1 || themeStore.themeIndex === 3 || themeStore.themeIndex === 4) {
        router.push({ path: '/sd-topup', query: { firstRechargeValue: amount } });
    } 
    else if (themeStore.themeIndex === 2) {
        walletPopupRef?.value?.openPopup(0)
        userStore.setFirstRechargeAmount(amount)
    }       
}
onMounted(() => {
    getActivityInfo();
    checkScroll();
    window.addEventListener('resize', checkScroll);
})

</script>